import { render, staticRenderFns } from "./AdminRequestsTable.vue?vue&type=template&id=5d730660&scoped=true"
import script from "./AdminRequestsTable.vue?vue&type=script&lang=js"
export * from "./AdminRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d730660",
  null
  
)

export default component.exports